import { IAutonumberCounter, templatesService } from "entities/template";
import { authContext } from "entities/user";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { filterOwnAutonumberCounters } from "../utils/autonumber-hydration";

export interface IUseAutonumberCountersResult {
    counters: IAutonumberCounter[];
    allCounters: IAutonumberCounter[];
    loading: boolean;
    error?: Error;
    reload: () => void;
}

export const useAutonumberCounters = (): IUseAutonumberCountersResult => {
    const userInfo = useContext(authContext);
    const [allCounters, setAllCounters] = useState<IAutonumberCounter[]>([]);
    const counters = useMemo(() => userInfo?.login
        ? filterOwnAutonumberCounters(allCounters, userInfo.login)
        : [], [allCounters, userInfo?.login]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error>();
    const [reloadKey, setReloadKey] = useState(0);

    const reload = useCallback(() => setReloadKey(value => value + 1), []);

    useEffect(() => {
        let active = true;
        if (!userInfo?.login) {
            setAllCounters([]);
            setLoading(false);
            return () => {
                active = false;
            };
        }

        setLoading(true);
        setAllCounters([]);
        setError(undefined);
        templatesService.loadAutonumberCounters()
            .then(result => {
                if (active) {
                    setAllCounters(result);
                }
            })
            .catch(caughtError => {
                if (active) {
                    setAllCounters([]);
                    setError(caughtError instanceof Error ? caughtError : new Error(String(caughtError)));
                }
            })
            .finally(() => {
                if (active) {
                    setLoading(false);
                }
            });

        return () => {
            active = false;
        };
    }, [reloadKey, userInfo?.login]);

    return { counters, allCounters, loading, error, reload };
};
